import { render, staticRenderFns } from "./attendancesetting.vue?vue&type=template&id=057e70d3"
import script from "./attendancesetting.vue?vue&type=script&lang=js"
export * from "./attendancesetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports